var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "c-btn c-btn--invisible",
      class: {
        "is-active": _vm.selected === true,
      },
      attrs: { type: "button" },
      on: { click: _vm.updateResidenceStatus },
    },
    [
      _c("Toggle", {
        staticClass: "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
        attrs: { isSelected: _vm.selected },
      }),
      _vm._v("Vis bare ledige\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }